import { gameConstants } from '../constants';

export function game(state = { data: null, round: null }, action) {
  switch (action.type) {
    case gameConstants.SET_DATA:
      const d = action.data;
      if (d === null) return { data: null, round: null };
      else
        return {
          ...state,
          data: { ...state.data, ...d },
        };
    case gameConstants.SET_GAMES:
      return {
        games: action.data,
      };
    case gameConstants.SET_ROUND:
      const round = action.data;
      return {
        ...state,
        round,
      };
    case gameConstants.ADD_PLAYERS:
      const newpls = action.data;
      const totalPlayers = [...state.data.players, ...newpls];
      return {
        ...state,
        data: { ...state.data, ...{ players: totalPlayers } },
      };
    default:
      return state;
  }
}
